import { render, staticRenderFns } from "./NewProfilePhoto.vue?vue&type=template&id=1573dffc&"
import script from "./NewProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./NewProfilePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports